import type { FaireProductEntity } from "../../entity_types/product";

export const p_472mmfx6ct: FaireProductEntity = {
  token: "p_472mmfx6ct",
  type: "product",
  name: "Hand Wash Refill",
  brandToken: "b_8aa5kchc2z",
  brandName: "Homecourt",
  imageUrl:
    "https://cdn.faire.com/fastly/e8ef70be3bb005826adc37d679032f0e256a431b95cda8ef956bf0212a937348.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f8318d7419c7982229a034f0cbb8f3b7b0c6f4a0ff9bc77dd0bb822cad9e3d8e.jpeg",
    "https://cdn.faire.com/fastly/8cddcc6f8819beb03f8e8a49ef759225d86cee1c6d98613071f0e5857ca3b8c9.jpeg",
    "https://cdn.faire.com/fastly/33d6335245cba1266ffbc2b05d171944f1f8ffcf399e93598a0832493031a784.jpeg",
    "https://cdn.faire.com/fastly/b9e10cc961a573855e433748ef7c54b8f90b5d32590257c7ff98388a38005aec.jpeg",
    "https://cdn.faire.com/fastly/51d21b1b60a47fc87bbc85ccb07ee46614bb610b93ee0b4a3189c49033ff1688.jpeg",
    "https://cdn.faire.com/fastly/23bae510c25b88e7100d40ea4dd9c612b4e5b16fb6db9788603a697c03c9af12.jpeg",
    "https://cdn.faire.com/fastly/9adfb6a2b08c88d81a167aa50ab80e150d57aee541c8a43bc91b21e5579c69ee.jpeg",
  ],
  priceDollars: 48.4,
  description:
    "Refill your favorite hand wash in a more sustainable way with Homecourt’s Eco-Friendly Hand Wash Refill. Designed for those who value sustainability without compromising on luxury, this biodegradable, gentle formula cleanses effectively while keeping hands soft and hydrated.\n\nHoused in a 32 fl oz refill bottle, it allows you to replenish your existing dispenser multiple times—reducing waste and extending the life of your original packaging. A natural, eco-conscious hand soap refill that turns an everyday routine into a mindful ritual.\n\n𝐖𝐡𝐲 𝐘𝐨𝐮’𝐥𝐥 𝐋𝐨𝐯𝐞 𝐈𝐭\n• Hand soap refill crafted with biodegradable, natural ingredients\n• Gentle formula with moisturizing properties to keep hands hydrated\n• Eco-friendly and sustainable alternative to single-use bottles\n• Plastic-free packaging designed to reduce environmental impact\n• Large 32 fl oz size provides multiple refills for long-lasting use\n• Same luxury fine fragrance as the original hand wash\n\n𝐇𝐨𝐰 𝐭𝐨 𝐔𝐬𝐞\nPour refill into your existing Homecourt Hand Wash and use as usual.\n\n𝐒𝐢𝐳𝐞\n32 fl oz / 946 ml\n\n𝐏𝐚𝐢𝐫𝐢𝐧𝐠 𝐑𝐞𝐜𝐨𝐦𝐦𝐞𝐧𝐝𝐚𝐭𝐢𝐨𝐧\nUse with Homecourt’s Luxury Hand Wash for a complete sink-side ritual, and pair with the Hand Cream to lock in hydration after cleansing.",
  tags: [],
  msrpDollars: 88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-28T15:36:20.129Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
